export const heading = { fontWeight: 'bold', fontSize: '1.8rem', pl: 1 };

export const toggleButtonStyles = (color) => { 
  return { mr: 2, mb: 1.5, p: 0, color: color } 
};

export const gridStyles = {
    height: 'calc(100vh - 155px)',
    width: '100%',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    borderRadius: 2,
    backgroundColor: 'white',
    overflow: 'hidden',
    '& .MuiDataGrid-cell': {
      fontSize: '0.8rem',
    },
    '& .MuiDataGrid-columnHeader': {
      fontSize: '0.9rem',
    },
  }